import wixWindow from 'wix-window';
import wixAnimations from 'wix-animations';
import wixData from 'wix-data';
import { fireBIEvent1 } from 'public/bi-events.js';
import { fireBIEvent2 } from 'public/bi-events.js';
import { fireBIEvent3 } from 'public/bi-events.js';
// ...

let timeline = wixAnimations.timeline();
let formFactor = wixWindow.formFactor;

//

$w.onReady(function () {
    getFaqData()
    if (formFactor !== "Mobile") {
        animationBoxes()
    }
    /// BI
    $w('#ctaLastFold').onClick(() => {
        const biFields = {
            cta_name: $w('#buttonctaLastFold').label,
            target_url: $w('#buttonctaLastFold').link,
        }
        fireBIEvent1(19, 9001, biFields);
    })
    $w("#stripComplianceAndCertifications").onViewportEnter((event) => {
        fireBIEvent2(19, 125102, { lp_name: '5' });
    });
    $w("#stripPhysicalDataSecurity").onViewportEnter((event) => {
        fireBIEvent2(19, 125102, { lp_name: '6' });
    });
    $w("#stripFAQ").onViewportEnter((event) => {
        fireBIEvent2(19, 125102, { lp_name: '7' });
    });
    $w("#lastStrip").onViewportEnter((event) => {
        fireBIEvent2(19, 125102, { lp_name: '8' });
    });
});

function animationBoxes() {
    let fadeOptions = {
        "duration": 600,
        "delay": 300

    };
    /// ENTER
    $w("#groupStage1").onViewportEnter((event) => {
        console.log("stage-1")
        hideAllImages(1)
        fireBIEvent2(19, 125102, { lp_name: '1' });

        $w("#imageStage1").show("fade", fadeOptions);
    });
    $w("#repeaterFaq1").onViewportEnter((event) => {
        console.log("stage-2")
        hideAllImages(2)
        fireBIEvent2(19, 125102, { lp_name: '2' });
        $w("#imageStage2").show("fade", fadeOptions);
    });
    $w("#repeaterFaq2").onViewportEnter((event) => {
        console.log("stage-3")
        hideAllImages(3)
        fireBIEvent2(19, 125102, { lp_name: '3' });
        $w("#imageStage3").show("fade", fadeOptions);
    });
    $w("#repeaterFaq3").onViewportEnter((event) => {
        console.log("stage-4")
        hideAllImages(4)
        fireBIEvent2(19, 125102, { lp_name: '4' });
        $w("#imageStage4").show("fade", fadeOptions);
    });

    function hideAllImages(index) {
        if (index !== 1) {
            $w("#imageStage1").hide("fade", fadeOptions)
        }
        if (index !== 2) {
            $w("#imageStage2").hide("fade", fadeOptions)
        }
        if (index !== 3) {
            $w("#imageStage3").hide("fade", fadeOptions)
        }
        if (index !== 4) {
            $w("#imageStage4").hide("fade", fadeOptions)
        }

    }

}

function faqReppeaters() {
    let repeatersArr = [{ "repeaterId": "#repeaterFaq1", "boxAnswerId": "#boxAnswer1", "containerItemId": "#containerItem1", "arrowId": "#arrowItem1", "devideId": "#lineBlackMobile1", "whiteDevideId": "#lineDevider1" },
        { "repeaterId": "#repeaterFaq2", "boxAnswerId": "#boxAnswer2", "containerItemId": "#containerItem2", "arrowId": "#arrowItem2", "devideId": "#lineBlackMobile2", "whiteDevideId": "#lineDevider2" },
        { "repeaterId": "#repeaterFaq3", "boxAnswerId": "#boxAnswer3", "containerItemId": "#containerItem3", "arrowId": "#arrowItem3", "devideId": "#lineBlackMobile3", "whiteDevideId": "#lineDevider3" }
    ]

    for (let index = 0; index < repeatersArr.length; index++) {
        $w(repeatersArr[index].repeaterId).forEachItem(($item, itemData, indexRepeater) => {
            ///// open the first question ///////
            // if (indexRepeater === 0) {
            //     $item(repeatersArr[index].boxAnswerId).expand()
            //     arrowAnimation(repeatersArr[index].arrowId, repeatersArr[index].repeaterId, indexRepeater, "none")
            // }
            $item(repeatersArr[index].containerItemId).onClick((event) => {
                let subCategoryStr = "FAQ Num: " + (index+1) + " / Question Num: " + (indexRepeater+1)
                let subCategoryID = "FAQnum" + (index+1) + "Q" + (indexRepeater+1)
                const biFields = {
                    subCategory: subCategoryStr,
                    subCategoryId: subCategoryID,
                }
                fireBIEvent3(19, 124902, biFields);

                if ($item(repeatersArr[index].boxAnswerId).collapsed) {
                    collapseAll(repeatersArr[index].repeaterId, repeatersArr[index].boxAnswerId)
                    $item(repeatersArr[index].boxAnswerId).expand()
                    arrowAnimation(repeatersArr[index].arrowId, repeatersArr[index].repeaterId, indexRepeater, "none")
                } else {
                    $item(repeatersArr[index].boxAnswerId).collapse()
                    arrowAnimation(repeatersArr[index].arrowId, repeatersArr[index].repeaterId, indexRepeater, "all")
                }
            });
        });

    }

    function collapseAll(repeaterId, boxAnswerId) {
        $w(repeaterId).forEachItem(($item) => {
            $item(boxAnswerId).collapse()
        });
    }

    function arrowAnimation(arrowId, repeaterId, indexAnim, hideAll) {
        $w(repeaterId).forEachItem(($item, itemData, indexRepeater) => {
            if (hideAll === "all") {
                moveArrow(0)
            } else {
                if (indexRepeater === indexAnim) {
                    moveArrow(180)
                } else {
                    moveArrow(0)
                }
            }

            function moveArrow(rotateIndex) {
                const arrow = $item(arrowId);
                timeline
                    .add(
                        arrow, {
                            "rotate": rotateIndex,
                            "duration": 250
                        },
                    )
                    .play();
            }
        });
    }

}

/// get data

let faqData1 = []
let faqData2 = []
let faqData3 = []

function getFaqData() {
    wixData.query("FAQ")
        .ascending("sort")
        .find()
        .then((results) => {
            let faqDataAll = results.items
            console.log(faqDataAll)
            for (let index = 0; index < faqDataAll.length; index++) {
                if (faqDataAll[index].repeaterNum === 1) {
                    faqData1.push(faqDataAll[index])
                }
                if (faqDataAll[index].repeaterNum === 2) {
                    faqData2.push(faqDataAll[index])
                }
                if (faqDataAll[index].repeaterNum === 3) {
                    faqData3.push(faqDataAll[index])
                }
            }
            ////
            $w('#repeaterFaq1').data = faqData1
            $w("#repeaterFaq1").forEachItem(($item, itemData, index) => {
                $item("#textQ1").text = itemData.question
                $item("#textA1").html = itemData.answer
                /// black rich text devider mobile ///
                if (formFactor === "Mobile") {
                    let blackTextHtml = itemData.answer.replace(/<p class="font_7">/g, `<p class="font_7" style="color: #000;">`);
                    $item("#textA1").html = blackTextHtml
                }

            });
            ///
            $w('#repeaterFaq2').data = faqData2
            $w("#repeaterFaq2").forEachItem(($item, itemData, index) => {
                $item("#textQ2").text = itemData.question
                $item("#textA2").html = itemData.answer
            });
            ///
            $w('#repeaterFaq3').data = faqData3
            $w("#repeaterFaq3").forEachItem(($item, itemData, index) => {
                $item("#textQ3").text = itemData.question
                $item("#textA3").html = itemData.answer
                /// black rich text devider mobile ///
                if (formFactor === "Mobile") {
                    let blackTextHtml = itemData.answer.replace(/<p class="font_7">/g, `<p class="font_7" style="color: #000;">`);
                    $item("#textA3").html = blackTextHtml
                }
            });

            faqReppeaters()
        })
        .catch((err) => {
            let errorMsg = err;
        });

}